import { Component, OnInit } from "@angular/core";
import { ContextLocationViewModel } from "src/app/_core/models/main/context-location.model";
import { LinkItem } from "src/app/_core/models/main/link-item.model";
import { Policies } from "src/app/_core/models/main/policies.enum";
import {
	GlobalService,
	MigaDePan,
} from "src/app/_core/providers/global.service";
import { getHomeMenuWithVisited } from "src/app/_core/constants/menu.constants";

@Component({
	selector: "app-powerbi",
	templateUrl: "./powerbi.component.html",
	styleUrls: ["./powerbi.component.scss"],
})
export class PowerbiComponent implements OnInit {
	public contextLocation: ContextLocationViewModel;
	private readonly menu: LinkItem[] = getHomeMenuWithVisited("/powerbi");
	constructor(private readonly _globalService: GlobalService) {
		const miga: MigaDePan[] = [
			{
				nombre: "header.menu.home.powerbi",
				url: window.location.href,
			},
		];
		this._globalService.limpiarMigas();
		this._globalService.actualizarMigas(miga);
	}

	ngOnInit(): void {
		this._globalService.setHeaderOptions(
			[],
			this.contextLocation,
			[],
			this.menu
		);
	}
}
